export default __webpack_public_path__ + "static/media/UNIVERSIDADE EM MOVIMENTO 10.02.2023.a5d279d2.mp3";